// $(document).ready(function(){

	// -- Dropdown --
	$(document).on('click', '.dropdown-toggle', function(e){
		e.preventDefault();
		console.log('click drop');
		$(this).parent('.dropdown').toggleClass('open');
	});


	// -- subMenu (mobile) --
	$('.hamburger').on('click', function(){
		// -- Reset mainMenu --
		$('body').removeClass('mainMenu--open');
		$('.icon__cross').removeClass('is-active');
		// -- subMenu --
		$('body').toggleClass('subMenu--open');
		$(this).toggleClass('is-active');
	});

	// -- mainMenu (mobile) --
	$('.icon__dots').on('click', function(){
		// -- Reset subMenu --
		$('body').removeClass('subMenu--open');
		$('.hamburger').removeClass('is-active');
		// -- mainMenu --		
		$('body').addClass('mainMenu--open');
		$('.icon__dots').css({'height':0});
		$(this).addClass('is-active');

	});

	// -- mainMenu (mobile) --
	$('.icon__cross').on('click', function(){
		$('body').removeClass('mainMenu--open');
		$('.icon__dots').css({'height':0});
		$(this).removeClass('is-active');
	});

// 	$('.main__nav li a:not(.dropdown-toggle)').on('click', function(){
// 		$('body').removeClass('mobileMenu--open');
// 		$('.hamburger').removeClass('is-active');
// 	});

// });

// -- Close dropdown when click outside --
$(document).mouseup(function(e) {
  var container = $('.dropdown-toggle');
  if (!container.is(e.target) && container.has(e.target).length === 0) {
		$('.dropdown').removeClass('open');
  }
});


// // -- Header fixed --
// $(document).on('scroll', function(){
// 	var scrollTop = $(this).scrollTop();
// 	var header = $('.header').outerHeight();
// 	if (scrollTop > header) {
// 		$('body').addClass('header--fixed');
// 	} else {
// 		$('body').removeClass('header--fixed');
// 	}
// });